<template>
  <Card title="提现记录" class="app-list">
    <div class="searchBox" v-if="false">
      <Input
        v-model="searchValue"
        class="input"
        search
        enter-button
        placeholder="输入商家名称"
        @on-search="onSearch"
      />
    </div>
    <div class="content">
      <Table
        tooltip-theme="light"
        max-height="1000"
        highlight-row
        :loading="loading"
        :columns="columns"
        :data="data"
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            v-if="row.status == '等待中'"
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="cancelWithdraw(row, index)"
          >撤销</Button>
        </template>
      </Table>
    </div>
    <div class="pageBox cardBox">
      <Page :current="current" :total="total" :page-size="limit" simple @on-change="changePage" />
    </div>
  </Card>
</template>

<script>
import axios from "axios";
import { financeRecord, cancelCashout } from "@/service/api";
export default {
  data() {
    return {
      loading: false,
      total: 0,
      current: 1,
      limit: 10,
      searchValue: "",
      columns: [
        {
          title: "ID",
          key: "id",
          sortable: true,
          // fixed: 'left',
          width: 80,
        },
        {
          title: "提现金额",
          key: "Cashwithdrawals",
          sortable: true,
          width: 120,
        },
        {
          title: "开户名称",
          key: "accountName",
          width: 150,
        },
        {
          title: "银行账号",
          key: "bankAccount",
          sortable: true,
          width: 180,
        },
        {
          title: "开户银行",
          key: "bankDeposit",
          // width: 150
        },
        {
          title: "提现状态",
          key: "status",
          width: 100,
        },
        {
          title: "操作",
          key: "menu",
          slot: "action",
          fixed: "right",
          width: 80,
        },
      ],
      data: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    changePage(page) {
      console.log(page);
      this.current = page;
      this.getData();
    },
    cancelWithdraw(row, index) {
      console.log("撤销：", row, index);
      let params = {
        record_id: row.id,
      };
      console.log(params, "params");
      cancelCashout(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$Message.success({
              content: res.data.msg || "操作成功!",
              duration: 3,
              background: true,
            });
            this.getData();
          } else {
            this.$Message.error({
              duration: 3,
              background: true,
              content: res.data.msg || "操作失败！",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$Message.error({
            duration: 3,
            background: true,
            content: "操作失败!",
          });
        });
    },
    getData() {
      this.loading = true;
      let params = {
        page: this.current,
        limit: this.limit,
        username: this.searchValue,
        invite: window.sessionStorage.getItem("inviteCode"),
      };
      financeRecord(params)
        .then((res) => {
          this.loading = false;

          console.log("res:", res);
          if (res.data.code == 0) {
            let data = res.data.data;
            this.total = data.count;
            this.data = data.list.map((item) => {
              let statusName;
              switch (item.status) {
                case 1:
                  statusName = "已处理";
                  break;
                case -1:
                  statusName = "已撤销";
                  break;
                case 0:
                  statusName = "等待中";
                  break;
                default:
                  statusName = "";
                  break;
              }
              return {
                id: item.id, // ID
                Cashwithdrawals: item.money, // 体现金额
                accountName: item.username, // 开户名称
                bankAccount: item.bankcard, // 银行账户
                bankDeposit: item.bankname, // 开户银行
                status: statusName, // 提现状态
              };
            });
          } else {
            this.$Message.error({
              duration: 3,
              background: true,
              content: res.data.msg || "操作失败！",
            });
          }
        })
        .catch((error) => {
          console.log("error: ", error);
        });
    },
    onSearch() {
      console.log("searchValue:", this.searchValue);
      this.current = 1;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.app-list {
  flex: 1;
  margin-top: 30px;
  height: max-content;
  > .content {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    width: 100%;
    box-sizing: border-box;
  }

  .pageBox {
    padding: 10px 0;
    margin-top: 2px;
  }

  .searchBox {
    padding: 20px 0;
    .input {
      width: 300px;
    }
  }
}

.poptipTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.QRcodeImg {
  width: 250px;
  height: 250px;
  object-fit: cover;
}
</style>
